import styled from 'styled-components';

export const Base = styled.div`
	// layout
	width: calc(100% - 68px);
	padding: 10px;
	padding-top: 8px;
	padding-bottom: 12px;
	padding-left: 14px;
	margin-left: 36px;
	align-self: flex-end;

	// style
	background-color: ${({ theme }) => theme.gray[100]};
	color: ${({ theme }) => theme.gray[1000]};
	border-radius: 18px;
	border-bottom-right-radius: 0px;
`;

export const SelectedElementsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	flex-wrap: wrap;
	padding-bottom: 4px;
	margin-left: -2px;
`;

export const Prompt = styled.div`
	padding-top: 4px;
	font-size: 13px;
	line-height: 20px;
	user-select: text;
	cursor: text;
`;
